import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiListTabber {
    constructor() {

    }

    addGadgetItem() {
    }

    clearGadgetItems() {
    }

    countGadgetItems() {
    }

    createComboBox() {
    }

    createListBox() {
    }

    createTabber() {
    }

    gadgetItemText() {
    }

    insertGadgetItem() {
    }

    modifyGadgetItem() {
    }

    removeGadgetItem() {
    }

    selectedGadgetItem() {
    }

    selectGadgetItem() {
    }
}
